import { render, staticRenderFns } from "./editReserveCatalog.vue?vue&type=template&id=4bffe9c9"
import script from "./editReserveCatalog.vue?vue&type=script&lang=js"
export * from "./editReserveCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports